import { render, staticRenderFns } from "./OverflowMenu.vue?vue&type=template&id=fa631588&"
import script from "./OverflowMenu.vue?vue&type=script&lang=ts&"
export * from "./OverflowMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports